import React from 'react';

import { useAppSelector } from '@store/index';
import { selectTheme } from '@features/ui/uiSlice';
import { cn } from '@/lib/utils';
import { useDocumentLanguage } from '@hooks/useDocumentLanguage';

/**
 * Scoped Tailwind/shadcn "island" for the authentication pages. Bridges the
 * existing Redux `uiSlice` theme to a local `.dark` class so shadcn design
 * tokens resolve — WITHOUT enabling Tailwind globally or touching the MUI-based
 * rest of the app. Wrap every revamped auth page in this.
 */
export function AuthLayout({ children }: { children: React.ReactNode }) {
  const theme = useAppSelector(selectTheme);
  useDocumentLanguage();

  return (
    <div className={cn('aiona-auth font-sans antialiased', theme === 'dark' && 'dark')}>
      <div className="min-h-screen w-full bg-background text-foreground">
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
